module.exports = __webpack_public_path__ + "img/vertical.52ac0ea2.svg";